export default {
    "name": "SettingsData",
    "kind": "HoudiniQuery",
    "hash": "a7ebdb7ead7a8c5717fca58d1e66c3ade9d6599f889da460395a09245e8bc3fa",

    "raw": `query SettingsData {
  session {
    permissions {
      SETTINGS_GLOBAL_ADMINISTRATOR
      SETTINGS_STORE_ADMINISTRATOR
    }
    id
  }
  settingValues {
    settingsConfig {
      importantConfigurationShown
      interfaceHistoryConfigurationShown
      interfacePreferenceConfigurationShown
      optionalConfigurationShown
      preferenceConfigurationShown
    }
  }
  settingValuesForConfig {
    id
    defaultValue
    description
    category: location
    name
    scope
    type: settingType
    value
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "session": {
                "type": "Session",
                "keyRaw": "session",

                "selection": {
                    "fields": {
                        "permissions": {
                            "type": "SessionPermissions",
                            "keyRaw": "permissions",

                            "selection": {
                                "fields": {
                                    "SETTINGS_GLOBAL_ADMINISTRATOR": {
                                        "type": "Boolean",
                                        "keyRaw": "SETTINGS_GLOBAL_ADMINISTRATOR",
                                        "visible": true
                                    },

                                    "SETTINGS_STORE_ADMINISTRATOR": {
                                        "type": "Boolean",
                                        "keyRaw": "SETTINGS_STORE_ADMINISTRATOR",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "settingValues": {
                "type": "SettingValues",
                "keyRaw": "settingValues",

                "selection": {
                    "fields": {
                        "settingsConfig": {
                            "type": "SettingsConfigSettingValues",
                            "keyRaw": "settingsConfig",

                            "selection": {
                                "fields": {
                                    "importantConfigurationShown": {
                                        "type": "String",
                                        "keyRaw": "importantConfigurationShown",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "interfaceHistoryConfigurationShown": {
                                        "type": "String",
                                        "keyRaw": "interfaceHistoryConfigurationShown",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "interfacePreferenceConfigurationShown": {
                                        "type": "String",
                                        "keyRaw": "interfacePreferenceConfigurationShown",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "optionalConfigurationShown": {
                                        "type": "String",
                                        "keyRaw": "optionalConfigurationShown",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "preferenceConfigurationShown": {
                                        "type": "String",
                                        "keyRaw": "preferenceConfigurationShown",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "settingValuesForConfig": {
                "type": "ConfigSettingValues",
                "keyRaw": "settingValuesForConfig",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "defaultValue": {
                            "type": "String",
                            "keyRaw": "defaultValue",
                            "nullable": true,
                            "visible": true
                        },

                        "description": {
                            "type": "String",
                            "keyRaw": "description",
                            "nullable": true,
                            "visible": true
                        },

                        "category": {
                            "type": "String",
                            "keyRaw": "category",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "scope": {
                            "type": "Scope",
                            "keyRaw": "scope",
                            "visible": true
                        },

                        "type": {
                            "type": "SettingTypeEnum",
                            "keyRaw": "type",
                            "visible": true
                        },

                        "value": {
                            "type": "String",
                            "keyRaw": "value",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=a49d6aa94957112fc129fc0f6f3f54442b6d15d638eed9833ae8eaf0f14b6f17";